/* eslint-disable no-param-reassign */

import { APP } from '../../commons/reducer';
import { createAction, createReducer } from '../../utils/reducer';
// Local constants
const PATH = 'shiphmentList/';
const TRANSACTION_PARAMS = `${PATH}TRANSACTION_PARAMS`;

// Global constants for saga
export const TRANSACTION_LIST = {
  GET_TRANSACTION_LIST: `${PATH}TRANSACTION_LIST`,
  GET_TRANSACTION_LIST_SUCCESS: `${PATH}TRANSACTION_LIST_SUCCESS`,
  GET_TRANSACTION_LIST_FAILED: `${PATH}TRANSACTION_LIST_FAILED`,
};

// actions
export const transactionListActions = {
  transactionParams: createAction(TRANSACTION_PARAMS, 'params'),
  getTransactionList: createAction(TRANSACTION_LIST.GET_TRANSACTION_LIST),
  getTransactionListSuccess: createAction(TRANSACTION_LIST.GET_TRANSACTION_LIST_SUCCESS, 'payload'),
  getTransactionListFailed: createAction(TRANSACTION_LIST.GET_TRANSACTION_LIST_FAILED, 'errorMsg'),
}

const initialState = {
  params: {
    errorMessage: '',
    error: false,
    loading: false,
    page: 1,
    limit: 10,
    total: 0
  },
  list: []
};

const transactionList = createReducer(initialState, {
  [TRANSACTION_PARAMS](state: any, action: any) {
    state.params = {
      ...state.params,
      ...action.params,
    };
  },
  [TRANSACTION_LIST.GET_TRANSACTION_LIST](state: any) {
    state.params.loading = true;
  },
  [TRANSACTION_LIST.GET_TRANSACTION_LIST_SUCCESS](state: any, action: any) {
    state.list = action.payload.data;
    state.params.total = action.payload.total || 0;
    state.params.page = action.payload.page || 1;
    state.params.limit = action.payload.limit || 10;
    state.params.loading = false;
  },
  [TRANSACTION_LIST.GET_TRANSACTION_LIST_FAILED](state: any, action: any) {
    state.params.error = true;
    state.params.loading = false;
    state.params.errorMessage = action.errorMsg || 'Oops, failed to get list.';
  },
  [APP.SERVER_FAILED](state: any) {
    state.params.loading = false;
  },
});

export default transactionList;